import { combineReducers } from "redux";
import {
  RECEIVE_BRAND_NAMES,
  RECEIVE_CATEGORY_NAMES,
} from "./register_actions";

const brands = (state = [], payload = {}) => {
  const { type, brands } = payload;
  return type === RECEIVE_BRAND_NAMES ? brands : state;
};

const categories = (state = [], payload = {}) => {
  const { type, categories } = payload;
  return type === RECEIVE_CATEGORY_NAMES ? categories : state;
};

export default combineReducers({ brands, categories });
